module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_7_3.65027d4d.jpeg";